import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["task"];
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import OpenModalButton from '../../button/OpenModalButton';
import LearnMoreModals from '../../modal/LearnMoreModals';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const HelpWidgetButton = _ref => {
  let {
      task
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackTaskInteraction
  } = useTracker();
  const LearnMoreModal = LearnMoreModals[task.key];
  if (LearnMoreModal) {
    return /*#__PURE__*/_jsx(OpenModalButton, Object.assign({
      onClick: () => trackTaskInteraction('open learn more modal', task.key),
      onModalClose: () => trackTaskInteraction('close learn more modal', task.key),
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.checklist.learnMore"
      }),
      use: "link"
    }, passThroughProps, {
      children: /*#__PURE__*/_jsx(LearnMoreModal, {
        task: task
      })
    }));
  }
  if (!task.helpWidgetLink) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return /*#__PURE__*/_jsx(KnowledgeBaseButton, Object.assign({
    onClick: () => trackTaskInteraction('click help widget link', task.key),
    url: task.helpWidgetLink,
    useZorse: true
  }, passThroughProps, {
    children: task.helpWidgetLinkText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.seeInstructions"
    })
  }));
};
export default HelpWidgetButton;